import { SideItemType } from '@common/enums';
import { DrawingShape, SideItemInfoModel } from '@common/models';

const emptyArray = [] satisfies SideItemInfoModel[];

/**
 * return an array of partial SideItemInfoModel records for a given shape
 * @param shape
 */
export const getSideItemsFromShape = (shape: DrawingShape): Partial<SideItemInfoModel>[] => {
    return (
        shape.removedElementsHistory?.edgesAndCorners?.map((edge) => {
            const drawingEdgeSideItem = edge?.drawingEdge.sideItem;
            const depth = drawingEdgeSideItem?.depth;
            const disabled = !!edge?.drawingEdge.customSideType;
            return {
                arrowInfo: edge.arrowInfo ?? undefined,
                sideType: edge.sideItemType,
                checked: true,
                disabled,
                ...(edge.sideItemType === SideItemType.WALL_SIDE && {
                    backsplash: {
                        checked: !!depth,
                        height: depth,
                    },
                }),
                ...(edge.sideItemType === SideItemType.WATERFALL && { waterfallHeight: depth }),
            };
        }) ?? emptyArray
    );
};
